import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { hasExtractManagementPermission } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { IDatasourceActions } from '../../../datasource/ServerApi/types/IDatasourceActions';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';
import { IWorkbookActions } from '../../../workbook/ServerApi/types/IWorkbookActions';
import { deleteExtractRefresh } from '../../actions/extractRefresh/DeleteExtractRefreshAction';

export const DeleteExtractRefreshEntityAction:
    IEntityAction<IExtractTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksDelete,
  translateName: Messages.delete_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: deleteExtractRefresh
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IExtractTaskInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return hasExtractManagementPermission(state, spaceItem, availableActions);
}
